import { Controller } from "@hotwired/stimulus"

// this controller toggles the disabled state of one or more inputs based on
// the value of a trigger input. If the trigger input is set to something,
// the target inputs will be disabled; otherwise, they will be enabled.
// A checkbox trigger disables the targets while it is checked. With a
// confirmMessage value, checking it asks first and cancelling unchecks it.
export default class extends Controller {
  static targets = ["triggerInput", "disableInput"]
  static values = { confirmMessage: String }

  toggleDisabled() {
    const trigger = this.triggerInputTarget
    const isCheckbox = trigger.type === "checkbox"

    // eslint-disable-next-line no-alert -- Native confirm, matching the cleaner show page's hx-confirm.
    if (isCheckbox && trigger.checked && this.hasConfirmMessageValue && !window.confirm(this.confirmMessageValue)) {
      trigger.checked = false
      return
    }

    const triggerValue = trigger.value
    const shouldDisable = isCheckbox ? trigger.checked : !(triggerValue === "" || triggerValue === undefined)

    this.disableInputTargets.forEach(input => {
      input.disabled = shouldDisable
      // need to handle select2 inputs separately since they
      // don't respond to the disabled attribute
      // this only works for select2 widgets created with the select-two Stimulus controller
      // it does involve destroying and re-initializing the select2 widget, but it ensures
      // that the disabled state is properly applied
      if (typeof input.dataset.controller === "string" && input.dataset.controller.includes("select-two")) {
        const selectTwoController = Stimulus.getControllerForElementAndIdentifier(input, "select-two")
        if (selectTwoController) {
          selectTwoController.reset()
        }
      }
    })
  }
}
